var _defs, _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #f4a11e;\n        stroke-width: 2.5px;\n      }\n\n      .st1, .st2 {\n        fill: #f4a11e;\n      }\n\n      .st2 {\n        opacity: .2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 65,
    cy: 65,
    r: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 40.231,
    y: 28.244,
    width: 49.537,
    height: 13.619
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "58.646 14.441 71.354 14.441 74.189 28.244 55.811 28.244 58.646 14.441"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "65 62.725 28.254 65.746 39.589 112.75 90.411 112.75 101.746 65.746 65 62.725"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "35.076 65.185 35.076 41.863 94.924 41.863 94.924 65.185"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 65.008,
    y1: 49.145,
    x2: 65.01,
    y2: 71.54
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 74.189,
    y1: 27.52,
    x2: 87.791,
    y2: 41.122
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 65,
    y1: 28.463,
    x2: 78.337,
    y2: 41.801
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.185,77.657h10.212c2.701,0,4.729.543,6.08,1.626,1.352,1.084,2.027,2.837,2.027,5.259,0,1.453-.217,2.607-.65,3.461-.434.854-1.172,1.613-2.217,2.275,1.146.484,1.994,1.186,2.543,2.104.547.918.822,2.193.822,3.824,0,2.524-.74,4.398-2.219,5.622s-3.557,1.836-6.234,1.836h-10.364v-26.007ZM66.129,82.171h-4.667v6.195h4.705c1.989,0,2.983-1.032,2.983-3.098s-1.008-3.098-3.021-3.098ZM66.281,92.803h-4.819v6.349h4.819c1.147,0,1.995-.229,2.543-.688.549-.459.822-1.301.822-2.524,0-2.09-1.121-3.136-3.365-3.136Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulk);
export default __webpack_public_path__ + "static/media/bulk.602de7c8ad3e69fa0fb7dcb799c9b582.svg";
export { ForwardRef as ReactComponent };